"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextField = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _constants = require("../../constants");
var _contexts = require("../../contexts");
var _constants2 = require("./constants");
var _jsxRuntime = require("react/jsx-runtime");
const TextField = ({
  label,
  multiline,
  name,
  placeholder,
  required,
  testId,
  type
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    register,
    formState: {
      errors
    }
  } = (0, _contexts.useRatingAndReviewForm)();
  const defaultValue = (0, _contexts.useRatingAndReviewWatch)(name);
  const setValueAs = value => {
    if (type === 'number') {
      return value === '' ? undefined : Number(value);
    }
    return value;
  };
  const slotProps = (0, _react.useMemo)(() => ({
    inputLabel: {
      shrink: true
    },
    htmlInput: {
      [_constants.DATA_TEST_ID]: getTestId(_constants2.TEXT_FIELD_INPUT)
    }
  }), [getTestId]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.TextField, {
    ...register(name, {
      setValueAs
    }),
    fullWidth: true,
    "data-testid": testId,
    error: !!errors[name],
    helperText: errors[name]?.message,
    id: name,
    defaultValue: defaultValue,
    label: label,
    multiline: multiline,
    placeholder: placeholder,
    required: required,
    slotProps: slotProps
  });
};
exports.TextField = TextField;
